/*
  Moves the Mobile menu drawer section's panel into Dawn's drawer shell.

  WHY A MOVE IS NEEDED AT ALL

  The panel has to end up inside `<details id="Details-menu-drawer-container">`,
  because that details/summary pair IS the hamburger: Dawn's `MenuDrawer` binds
  to them and the slide-in is a CSS rule on
  `details[open].menu-opening > .menu-drawer`. But Liquid sections cannot read
  each other's settings, so a section in the header group cannot hand its
  settings to the snippet the header renders. The section therefore renders the
  finished panel offstage and this puts it where it belongs.

  Everything is still rendered by Liquid - images, collection URLs, blocks -
  so this moves finished HTML rather than building any.

  It runs before the drawer can be opened (the shell is inert until Dawn's own
  script binds), and re-runs on `shopify:section:load` so edits in the theme
  editor appear immediately.
*/
(function () {
  /*
    Both the drawer shell and the section request this file, so without a guard
    the IIFE runs twice. The second run found the (now empty) offstage wrapper,
    cleared the mount and left the drawer blank - the panel had already been
    moved out by the first run.
  */
  if (window.NischeDrawerMount) return;
  window.NischeDrawerMount = true;

  var PANEL = '[data-nis-panel]';
  var MOUNT = '[data-nis-mount]';
  var SOURCE = '.nis-drawer-source';

  /*
    The panel that is still sitting in its section wrapper - i.e. the one that
    has not been mounted yet. Identifying it by position rather than by taking
    the first match matters after a section reload, when a freshly rendered
    panel and the previously mounted one are both in the document, and the
    mounted one comes first in DOM order.
  */
  function findSource() {
    var all = document.querySelectorAll(PANEL);
    for (var i = 0; i < all.length; i++) {
      if (all[i].closest(SOURCE)) return all[i];
    }
    return null;
  }

  function mount() {
    var panel = findSource();
    var target = document.querySelector(MOUNT);
    if (!panel || !target) return;

    /*
      Move the panel ELEMENT, not its children.

      Moving the children left them outside `#nis-panel-<section.id>`, which is
      exactly what the section's own <style> block scopes its rules to - so
      every setting that works through CSS (image height, darken, card and strip
      colours, icon colour) silently did nothing. It looked correct only because
      the static defaults happen to match the schema defaults.

      Taking the element with them keeps that id wrapped around the content, so
      section-scoped CSS lands where it was written to.
    */
    target.textContent = '';
    panel.classList.remove('nis-panel-offstage');
    panel.classList.add('nis-panel-mounted');
    target.appendChild(panel);

    /* The menu background is a setting on the section but belongs on Dawn's
       drawer element, which is outside the section's markup. */
    var bg = panel.getAttribute('data-drawer-bg');
    var drawer = target.closest('.nis-drawer');
    if (bg && drawer) drawer.style.backgroundColor = bg;

    /* The shell renders a plain menu as a fallback for the case where this
       section has not been added. Once the real panel is in, say so - the CSS
       uses it to drop the fallback's own padding. */
    target.setAttribute('data-nis-mounted', 'true');

    /* The section's own wrapper stays in the page and is now empty; the theme
       editor re-renders into it, and the next mount picks that fresh panel up
       via findSource(). */
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mount);
  } else {
    mount();
  }

  /* Theme editor: fires after Shopify re-renders a section the merchant just
     edited. Cheap enough to run for any section - the selectors miss instantly
     when it is not ours. */
  document.addEventListener('shopify:section:load', mount);
})();
